import { OrganizationTypes, TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { OrganizationType as OldOrganizationType } from '../../../interfaces/organizations';

export const OLD_ORG_TYPE_MAP: Record<TOrganizationTypes, OldOrganizationType> = {
  [OrganizationTypes.Bank]: OldOrganizationType.BANK,
  [OrganizationTypes.Insurance]: OldOrganizationType.INSURANCE,
  [OrganizationTypes.Mfo]: OldOrganizationType.MFO,
  [OrganizationTypes.EducationalOrganization]: OldOrganizationType.SCHOOL,
  [OrganizationTypes.Broker]: OldOrganizationType.BROKER,
  [OrganizationTypes.Npf]: OldOrganizationType.NPF,
  [OrganizationTypes.Leasing]: OldOrganizationType.LEASING,
  [OrganizationTypes.Marketplace]: OldOrganizationType.MARKETPLACE,
  [OrganizationTypes.Bankruptcy]: OldOrganizationType.BANKRUPTCY,
  [OrganizationTypes.University]: OldOrganizationType.UNIVERSITY,
  [OrganizationTypes.Bookmaker]: OldOrganizationType.BOOKMAKER,
  [OrganizationTypes.OfflineSchool]: OldOrganizationType.OFFLINE_SCHOOL,
};
